import { useTheme, useMediaQuery, Box } from '@mui/material';
import React from 'react'

export default function Skeleton() {
    const theme = useTheme();
    // const ltxs = useMediaQuery(theme.breakpoints.down("xs"));
    const ltsm = useMediaQuery(theme.breakpoints.down("sm"));
    return (
        <div className="ui-glassmoprhic-bg ui-padding--16">
            <Box display="flex" flexDirection="row">
                <div className="skeleton-box ui-width--124 ui-height--24 ui-border--r6"></div>
                <Box flex={1}></Box>
                <div className="skeleton-box ui-width--56 ui-height--24 ui-border--r6"></div>
            </Box>
            <div className="ui-padding--8"></div>
            <Box minHeight={ltsm ? 124 : 136} maxHeight={136} className="ui-width--full skeleton-box">
            </Box>
            <div className="ui-padding--6"></div>
            <Box display="flex" flexDirection="row">
                {[1, 2, 3, 4].map((value) => (
                    <Box flex={1} key={value} className="ui-rect--36 skeleton-box"></Box>
                ))}
            </Box>
            <div className="ui-padding--8"></div>
            <div className="skeleton-box ui-padding--16 ui-width--full"></div>
        </div>
    )
}
